import { AdsApi, AdsProps, PluginType } from '@accedo/one-plugin-sdk';
import { ErrorBoundary } from '@dynamic/ui';
import { createRef, Suspense, useMemo } from 'react';
import { ref } from 'valtio';

import { useGlobalContext } from '#/components/useGlobalContext';
import { useConfig } from '#/hooks';
import { getCcpaOutOutSetting } from '#/service/user/settings';

import pluginManager from '../pluginManager';
import { adsStoreActions } from './adsStore';

const onError = (error: Error, stack: string) => {
  console.error('Ad plugin error', error, stack);
};

const AdsManager = () => {
  const {
    boot: { isPluginManagerReady },
  } = useGlobalContext();
  const {
    features: { ads },
  } = useConfig();

  const ccpaOptOut = getCcpaOutOutSetting();

  const adComponents = useMemo(() => {
    if (!ads || !isPluginManagerReady) {
      return null;
    }

    return ads.map((adConfig) => {
      const AdComponent = pluginManager.getPluginComponent<AdsProps<any, any>>({
        type: PluginType.Ads,
        id: adConfig.plugin?.id,
        optional: true,
      });
      const apiRef = ref(createRef<AdsApi>());
      adsStoreActions.addAds({ apiRef, properties: adConfig.properties });

      return (
        <ErrorBoundary key={adConfig.key} onError={onError}>
          <Suspense fallback={null}>
            <AdComponent apiRef={apiRef} ccpaOptOut={ccpaOptOut} />
          </Suspense>
        </ErrorBoundary>
      );
    });
  }, [ads, ccpaOptOut, isPluginManagerReady]);

  if (!adComponents?.length) {
    return null;
  }

  return <>{adComponents}</>;
};

export default AdsManager;
